import EnergyInfoBox from './energy-info-box';
export default EnergyInfoBox;
